import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { TranslateService } from '@tolgee/ngx';
import { Observable, catchError, throwError, switchMap, of } from 'rxjs';
import { NotificationService } from 'src/app/notifications/notification.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private toast: HotToastService,
    private route: Router,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private http: HttpClient
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: true,
    });
    return next
      .handle(req)
      .pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 401 && !req.url.includes('/user/login') && !req.url.includes('/user/oauth/token')) {
            return this.handle401Error(req, next);
          }
          return throwError(() => error);
        })
      );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.http.post(`${environment.apiUrl}/user/refresh`, {}, { withCredentials: true }).pipe(
        switchMap(() => {
          this.isRefreshing = false;
          return next.handle(request);
        }),
        catchError((error) => {
          this.isRefreshing = false;
          this.notificationService.reset();
          this.route.navigate(['/logout']);
          return throwError(() => error);
        })
      );
    }

    return this.refreshTokenSubject.pipe(
      switchMap(() => next.handle(request))
    );
  }

  private handleAuthError(
    err: HttpErrorResponse,
    requestUrl: string
  ): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
    //this.toast.error("Unauthorized. Please login again.");
    //this.translateService.translate('Unauthorized. Please login again.').subscribe(res => this.toast.error(res));

    if (!requestUrl.includes('/user/login')) {
      // Reset notification service on logout
      this.notificationService.reset();
        
      this.route.navigate(['/logout']);
    }

      return throwError(() => err);
    } else {
      //this.translateService.translate('Oops, something went wrong, try again later.').subscribe(res => this.toast.error(res));
    }
    return throwError(() => err);
  }
}
